import React, { HTMLAttributes } from 'react';
import clsx from 'clsx';
import Icon from '../Icon/Icon';
import Grid from '../GridRow/GridRow';
import classes from './styles/notificationInline.module.scss';
import { NotificationTypeEnum } from './types';

interface INotification extends HTMLAttributes<HTMLDivElement> {
    text: string;
    type: NotificationTypeEnum;
}

const NotificationInline = ({ text, type = NotificationTypeEnum.SUCCESS, ...rest }: INotification) => {
    const styles = clsx(
        classes.main,
        type === NotificationTypeEnum.ERROR && classes.error,
        type === NotificationTypeEnum.SUCCESS && classes.success,
        type === NotificationTypeEnum.WARNING && classes.warning,
    );

    const iconType = (() => {
        switch (type) {
            case NotificationTypeEnum.ERROR:
                return 'error';
            case NotificationTypeEnum.SUCCESS:
                return 'ok';
            case NotificationTypeEnum.WARNING:
                return 'warning';
            default:
                return null;
        }
    })();

    return (
        <Grid gutter={8} alignRow={'center'} className={styles} {...rest}>
            {iconType && <Icon className={classes.icon} icon={iconType} />}
            {text}
        </Grid>
    );
};

export default NotificationInline;
